import React, { MouseEventHandler } from 'react';

import { Button } from '@material-ui/core';

export interface EeButtonProps {
  label: string;
  color: 'primary' | 'secondary';
  variant: 'outlined' | 'contained';
  disabled?: boolean;
  onClick?: MouseEventHandler<any>;
}

export const EeButton: React.FC<EeButtonProps> = ({
  label,
  color,
  variant,
  disabled,
  onClick,
}) => {
  return (
    <Button
      onClick={onClick}
      color={color}
      variant={variant}
      disabled={disabled}
    >
      {label}
    </Button>
  );
};
